import HomeCard from "../HomeCard";
import "./HomeCard3.css";

const HomeCard3 = () => {
    return <HomeCard className={"home-card-3"} itemType={"gather"} itemKey={11} itemName="신한 라이프 윈터타운" itemDesc="메타버스에 감성을 더하다"/>
};

export default HomeCard3;
